<template>
	<span @touchstart="click" @click="click" :style="{float: pull}">
		<span v-if="name" :class="{fal:true,[`fa-${name}`]:true}" :style="{fontSize:`${size}px`, color}"></span>
		<span 
			v-if="iconSvg" 
			class="icon-src" 
			:style="{width:`${size}px`, height:`${size}px`, color, backgroundImage:`url(/src/assets/icons/${iconSvg}.svg)`}"
		>
		</span>
	</span>
</template>

<script>
	export default  {
	    props: {
	    	name:{
	    		type:String,
	    		default:'key'
	    	},
	    	size:{
	    		type:[Number,String],
	    		default:14
	    	},
	    	pull:{
	    		type:String,
				default:'none'
			},
	    	color:String,
	    	iconSvg:String
	    },
	    methods:{
	    	click(){
	    		this.$emit('press');
	    	}
	    }
	};
</script>

<style scoped>
	.icon-src{
		background-position: center;
		background-size: cover;
		display: inline-block;
	}

	.fa{
		vertical-align: middle;
	}

</style>